<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Firma"
    }
</script>

<style scoped>

</style>